import SearchCentersClass from './SearchCenters.model';

export default class VaccinationCenters extends SearchCentersClass {
  static moreFilter(center, filters) {
    let { show } = center;
    const { types } = filters;

    types.forEach((type) => {
      if (show) {
        if (type === 'without-appointment') {
          show = center.hasNoAppointementOption();
        } else if (type === 'vac-5-11') {
          show = center.hasFiveElevenCenter();
        }
      }
    });

    return show;
  }

  clone() {
    return new VaccinationCenters(this.serverData);
  }
}
